import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatBot } from './components/chat-bot/chat-bot';

@Component({
  selector: 'app-root',
  standalone:true,
  imports: [RouterOutlet, ChatBot],
  template: `<router-outlet></router-outlet><app-chat-bot></app-chat-bot>`,
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('chatbot-frantinco');
}
